import { render } from "./CreateVATRates.vue?vue&type=template&id=c0e94c74"
import script from "./CreateVATRates.vue?vue&type=script&lang=js"
export * from "./CreateVATRates.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Pitch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__